import React from 'react';
import QuadProd from './QuadProd';
import { ArtigosDB } from '../ArtigosDB';

function ProducaoArt() {
  return (
    <section className="services">
            <div className="container">
                <div className="row">
                    <h2>Artigos</h2>
                    
                  {
                    ArtigosDB.map((user, i) => {
                    return (
                        <QuadProd  
                            key={i} 
                            titulo={ArtigosDB[i].titulo} 
                            meio={ArtigosDB[i].meio}
                            link={ArtigosDB[i].link} 
                            data={ArtigosDB[i].data} 
                            text1={ArtigosDB[i].text1} 
                            text2={ArtigosDB[i].text2} 
                            icon={ArtigosDB[i].icon}
                        />
                        );
                    })
                  }

                </div>
              </div>
    </section>
    

  );
}

export default ProducaoArt;